import { ClientOnly } from '~/decorators'
import { containerScoped } from '~/decorators/dependency-container'
import { Route } from 'vue-router/types/router'

@ClientOnly
@containerScoped()
export default class AdmanAdsService {
  constructor() {}

  private getAdman() {
    return window.Adman || { ws() {} }
  }

  private getAdmanAds() {
    return window._admanLastWsAsHash || {}
  }

  public refreshAllSlots() {
    const admanAds = this.getAdmanAds()

    this.refreshInnovativeFormats()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [_ws, ad] of Object.entries(admanAds) as any) {
      try {
        ad.reload('', true)
      } catch (_error) {
        // ignore adman errors
      }
    }
  }

  public refreshInnovativeFormats(route?: Route) {
    const adman = this.getAdman()

    adman.globalProfileOption = {
      viewCls: route?.meta?.viewCls ? 'enable' : undefined
    }

    if (adman?.adunit) {
      const admanElems = document.querySelectorAll(
        '.adman-sticky, #adman-floating-player'
      )
      for (const elem of Array.from(admanElems)) {
        elem.remove()
      }

      adman.adunit({
        id: 397,
        h: 'https://x.grxchange.gr',
        inline: true
      })
    }
  }
}
